import { Observable } from 'rxjs';
import { User } from '../models';

export interface UsersFilters {
    rolesIds?: string[];
}

export abstract class UsersService {
    abstract changeUserPassword(
        userId: string,
        currentPassword: string,
        newPassword: string,
        newConfirmationPassword: string
    ): Promise<void>;

    abstract createUser(name: string, email: string, roleId: string, canTakeControlOfEscalatedTickets: boolean, phone?: string, tagsIds?: string[]): Promise<void>;

    abstract deleteUser(id: string): Promise<void>;

    abstract resetPasswordRequest(email: string): Promise<void>;

    abstract resendConfirmationEmail(email: string): Promise<void>;

    abstract updateMultifactorAuthenticationToTenantsUsers(tenantId: string, action: 'add'|'remove'): Promise<any>;

    abstract updateUser(
        id: string,
        data: { canTakeControlOfEscalatedTickets?: boolean; name?: string; roleId?: string; photo?: string; phone?: string; tagsIds?: string[], mfaEnabled?: boolean }
    ): Promise<any>;

    abstract updateMultipleUsers(
        users: {
            id: string,
            data: { canTakeControlOfEscalatedTickets?: boolean; name?: string; roleId?: string; photo?: string; phone?: string; tagsIds?: string[], mfaEnabled?: boolean }
        }[]
    ): Promise<any>;

    abstract user(userId: string): Promise<User | undefined>;

    abstract users(filters?: UsersFilters, includeDeleted?: boolean): Observable<User[]>;
}
